// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-interfaces_wrapper__zN8-Z {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;

  overflow: hidden;
  display: flex;
  flex-direction: column;

  box-sizing: border-box;
  width: 100%;
  height: 100%;

  font-weight: 700;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--textColor);

  outline: none;
}

.user-interfaces_wrapper__zN8-Z,
.user-interfaces_wrapper__zN8-Z * {
  font-family: Montserrat, sans-serif;
}

.user-interfaces_wrapper__zN8-Z *,
.user-interfaces_wrapper__zN8-Z *::before,
.user-interfaces_wrapper__zN8-Z *::after {
  box-sizing: inherit;
}

.user-interfaces_bottomBar__HpiQ6 {
  pointer-events: none;

  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: flex-end;

  margin-top: auto;
  padding: 0px 20px 20px 20px;

  background: var(--controlbarBackgroundColor); /* backwards compatible */

  transition: opacity 0.2s;
}

@supports (color: lab(from red l 1 1% / calc(alpha + 0.1))) {
.user-interfaces_bottomBar__HpiQ6 {
  background: linear-gradient(
    to bottom,
    color(from var(--controlbarBackgroundColor) srgb r g b / var(--controlbarBackgroundOpacity)),
    color(from var(--controlbarBackgroundColor) srgb r g b / calc(var(--controlbarBackgroundOpacity) * 0.1 + 0.9))
  );
}
}

.user-interfaces_bottomBar__HpiQ6 > * {
    pointer-events: all;
  }

.user-interfaces_bottomBar__HpiQ6.user-interfaces_hidden__Jej1g {
    opacity: 0;
  }

.user-interfaces_bottomBar__HpiQ6.user-interfaces_hidden__Jej1g > * {
      pointer-events: none;
    }

.user-interfaces_buttonsSection__5QoyR {
  display: flex;
  flex: none;
  flex-direction: row;
  gap: 30px;
  align-items: center;
}

.user-interfaces_buttonsSection__5QoyR > *:first-child:not(.left-side),
.user-interfaces_buttonsSection__5QoyR > *.left-side + *.right-side {
  margin-left: auto;
}

.user-interfaces_timelineWrapper__zZ-WZ {
  display: flex;
  gap: 20px;
  align-items: center;
}

.user-interfaces_timelineWrapper__zZ-WZ > button:first-child {
  margin-left: auto;
}

.user-interfaces_mobilePlayControls__Fb022 {
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: space-between;

  width: 50%;
  max-width: 400px;
}

.user-interfaces_timelineTimerTop__c01yy {
  display: none;
}

.smallScreen .user-interfaces_bottomBar__HpiQ6 .user-interfaces_buttonsSection__5QoyR {
    gap: 20px;
  }

.smallScreen .user-interfaces_timelineTimer__vhLca {
    display: none;
  }

.smallScreen .user-interfaces_timelineTimerTop__c01yy {
    display: block;
    padding-top: 12px;
  }

.smallScreen .user-interfaces_timelineTimerTop__c01yy,.smallScreen .user-interfaces_timelineTimerTop__c01yy span {
    font-size: 12px !important;
  }
`, "",{"version":3,"sources":["webpack://./src/components/user-interfaces/user-interfaces.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,OAAO;;EAEP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;;EAEtB,sBAAsB;EACtB,WAAW;EACX,YAAY;;EAEZ,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,uBAAuB;;EAEvB,aAAa;AACf;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;;EAEpB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;;EAEzB,gBAAgB;EAChB,2BAA2B;;EAE3B,4CAA4C,EAAE,yBAAyB;;EAOvE,wBAAwB;AAa1B;;AA/BA;AAAA;EAYE;;;;GAIC;AAeH;AAAA;;AAXE;IACE,mBAAmB;EACrB;;AAEA;IACE,UAAU;EAKZ;;AAHE;MACE,oBAAoB;IACtB;;AAIJ;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;;EAE9B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAGE;IACE,SAAS;EACX;;AAEA;IACE,aAAa;EACf;;AAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;AAEA;IAEE,0BAA0B;EAC5B","sourcesContent":[".wrapper {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n\n  font-weight: 700;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: var(--textColor);\n\n  outline: none;\n}\n\n.wrapper,\n.wrapper * {\n  font-family: Montserrat, sans-serif;\n}\n\n.wrapper *,\n.wrapper *::before,\n.wrapper *::after {\n  box-sizing: inherit;\n}\n\n.bottomBar {\n  pointer-events: none;\n\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  justify-content: flex-end;\n\n  margin-top: auto;\n  padding: 0px 20px 20px 20px;\n\n  background: var(--controlbarBackgroundColor); /* backwards compatible */\n  background: linear-gradient(\n    to bottom,\n    color(from var(--controlbarBackgroundColor) srgb r g b / var(--controlbarBackgroundOpacity)),\n    color(from var(--controlbarBackgroundColor) srgb r g b / calc(var(--controlbarBackgroundOpacity) * 0.1 + 0.9))\n  );\n\n  transition: opacity 0.2s;\n\n  & > * {\n    pointer-events: all;\n  }\n\n  &.hidden {\n    opacity: 0;\n\n    & > * {\n      pointer-events: none;\n    }\n  }\n}\n\n.buttonsSection {\n  display: flex;\n  flex: none;\n  flex-direction: row;\n  gap: 30px;\n  align-items: center;\n}\n\n.buttonsSection > *:first-child:not(:global(.left-side)),\n.buttonsSection > *:global(.left-side) + *:global(.right-side) {\n  margin-left: auto;\n}\n\n.timelineWrapper {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n.timelineWrapper > button:first-child {\n  margin-left: auto;\n}\n\n.mobilePlayControls {\n  display: flex;\n  align-items: center;\n  align-self: center;\n  justify-content: space-between;\n\n  width: 50%;\n  max-width: 400px;\n}\n\n.timelineTimerTop {\n  display: none;\n}\n\n:global(.smallScreen) {\n  .bottomBar .buttonsSection {\n    gap: 20px;\n  }\n\n  .timelineTimer {\n    display: none;\n  }\n\n  .timelineTimerTop {\n    display: block;\n    padding-top: 12px;\n  }\n\n  .timelineTimerTop,\n  .timelineTimerTop span {\n    font-size: 12px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `user-interfaces_wrapper__zN8-Z`,
	"bottomBar": `user-interfaces_bottomBar__HpiQ6`,
	"hidden": `user-interfaces_hidden__Jej1g`,
	"buttonsSection": `user-interfaces_buttonsSection__5QoyR`,
	"timelineWrapper": `user-interfaces_timelineWrapper__zZ-WZ`,
	"mobilePlayControls": `user-interfaces_mobilePlayControls__Fb022`,
	"timelineTimerTop": `user-interfaces_timelineTimerTop__c01yy`,
	"timelineTimer": `user-interfaces_timelineTimer__vhLca`
};
export default ___CSS_LOADER_EXPORT___;
